import { render, staticRenderFns } from "./RateVersionHistory.vue?vue&type=template&id=2d4b539e&scoped=true"
import script from "./RateVersionHistory.vue?vue&type=script&lang=js"
export * from "./RateVersionHistory.vue?vue&type=script&lang=js"
import style0 from "./RateVersionHistory.vue?vue&type=style&index=0&id=2d4b539e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b539e",
  null
  
)

export default component.exports